import { cn } from '@/lib/utils';
import { PartialSheet } from '../sheets';
import React from 'react';
import { AppAlert } from '../app-alert';
import { Navbar } from '../navbar';
import { Footer } from '../footer';
import { Separator } from '../ui/separator';
import { BaselineNavigation } from '../baseline-navigation';
import { ErrorBoundaryFallback } from '../fallback';
import { ErrorBoundary } from 'react-error-boundary';

export const LayoutDocument = ({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={cn(className)}>
      <PartialSheet />
      <React.Suspense fallback={null}>
        <ErrorBoundary fallback={<ErrorBoundaryFallback />}>
          <AppAlert />
        </ErrorBoundary>
      </React.Suspense>
      <React.Suspense fallback={null}>
        <Navbar />
      </React.Suspense>
      {children}
      <div className="bg-black">
        <React.Suspense fallback={null}>
          <Footer />
        </React.Suspense>
      </div>
      <div className="bg-black">
        <React.Suspense fallback={null}>
          <Separator className="bg-white/10" />
          <BaselineNavigation />
        </React.Suspense>
      </div>
    </div>
  );
};
